module.exports = __webpack_public_path__ + "img/fullscreen-restore.312db0e1.svg";